import { Outlet } from 'react-router';

import { RequireAuth } from '@sorare/core/src/routing/RequireAuth';

const Layout = () => {
  return (
    <RequireAuth>
      <Outlet />
    </RequireAuth>
  );
};

export default Layout;
